import React,{useEffect, useState} from 'react'
import Header from '../../../components/header/Header'
import Footer from '../../../components/footer/Footer'
import { useSelector, useDispatch } from 'react-redux';
import { selectFilterdata } from '../../../slice/filterSlice';
function Categorydetail() {
    const [filterData, setFilterData] = useState([]);
  const appliedFilters = useSelector((selectFilterdata)=> selectFilterdata?.filter?.filterdata?.filterdata);


  return (
    <>
    <Header/>

    {appliedFilters?.map((res, index) => (
      <div className="card mb-3" key={index}>
        <div className="card-body">
          {res.userId.firstName && (
            <>
              <h5 className="card-title">Name:</h5>
              <p className="card-text">{res.userId.firstName}</p>
            </>
          )}
          {res.userId.lastname && (
            <>
              <h5 className="card-title">Last Name:</h5>
              <p className="card-text">{res.userId.lastname}</p>
            </>
          )}
          {res.userId.bio && (
            <>
              <h5 className="card-title">Bio:</h5>
              <p className="card-text">{res.userId.bio}</p>
            </>
          )}
          <button>Hire Me</button>
        </div>
      </div>
    ))}
    <Footer/>
    </>
  )
}

export default Categorydetail
